<div @show class="body" [formGroup]="formGroup">

    <quill-editor class="note-form quill" theme="snow" [format]="'html'" formControlName="note" [modules]="quillModules" [placeholder]="placeholder"></quill-editor>

    <div class="hint">

        <mat-icon class="icon">
            info
        </mat-icon>
        <div class="text-wrapper">
            Die Notiz soll dazu dienen, Ihre Änderungen für andere nachvollziehbar zu machen. 
            Angezeigt wird sie unter anderem in den Bearbeitungsverläufen.
        </div>

    </div>

</div>